import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Loader, Table } from '@itds/elements/index.js';

import Api from '@carrier/utils/Api';

const Relationships = ({ vendor }) => {
  const navigate = useNavigate();
  const [carriers, setCarriers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Api.loadCarriers().then(({ data }) => {
      setCarriers(data);
      setLoading(false);
    });
  }, []);

  return loading ? (
    <Loader />
  ) : (
    <Table
      columns={[
        {
          id: 'name',
          label: 'Name',
          render: r => {
            const carrier = carriers.find(c => c.id === r.carrier_id);

            return carrier.name;
          }
        },
        {
          id: 'api_token',
          label: 'API Token',
          styles: { textAlign: 'right' }
        }
      ]}
      data={vendor.vendor_carrier_relationships}
      onRowClick={r => navigate(`/carriers/${r.carrier_id}/vendors/${r.id}`)}
      placeholder='New Carrier Relationships Yet'
    />
  );
};

Relationships.propTypes = {
  vendor: PropTypes.object
};

export default Relationships;
